

// export default CallToActions;
import React, { useState, useEffect } from "react";
import { getSubscribe } from "../../redux/slices/common";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

const CallToActions = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { subsApply } = useSelector((state) => state.common);
  const [isValidEmail, setIsValidEmail] = useState(true); // New state for email validation
  const [responseMessage, setResponseMessage] = useState(""); // New state for response message
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (subsApply && loading) {
      setLoading(false);
      setResponseMessage(subsApply.message || "Success"); // Update with your actual response property
      setTimeout(() => {
        setResponseMessage("");
        setEmail("");
      }, 2000);
    }
  }, [subsApply]);

  const validateEmail = (value) => {
    // Simple email validation using a regular expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  // const handleSubmit = () => {
  //   const userId1 = sessionStorage.getItem("rslkey");
  //   const userId = userId1?.replace(/^"(.*)"$/, "$1"); // Use optional chaining

  //   // Validate email before dispatching
  //   if (validateEmail(email)) {
  //     const obj = {
  //       userId: userId,
  //       email: email,
  //     };
  //    
  //     dispatch(getSubscribe(obj));
  //   } else {
  //     setIsValidEmail(false); // Set validation state to false
  //   }
  // };

  const handleSubmit = () => {
    const userId1 = sessionStorage.getItem("rslkey");
    const userId = userId1?.replace(/^"(.*)"$/, "$1"); // Use optional chaining

    // Validate email before dispatching
    if (validateEmail(email)) {
      const obj = {
        userId: userId,
        email: email,
      };
      setLoading(true);
      dispatch(getSubscribe(obj));
    } else {
      setIsValidEmail(false);
    }
  };


  return (
    <section className="layout-pt-md layout-pb-md bg-dark-3">
      <div className="container">
        <div className="row y-gap-30 justify-between items-center">
          <div className="col-auto">
            <div className="row y-gap-20  flex-wrap items-center">
              <div className="col-auto">
                <div className="icon-newsletter text-60 sm:text-40 text-white" />
              </div>
              <div className="col-auto">
                <h4 className="text-26 text-white fw-600">
                  Your Travel Journey Starts Here
                </h4>
              </div>
            </div>
          </div>

          <div className="col-auto">
            <div className="single-field -w-410 d-flex x-gap-10 y-gap-20">
              <div>
                <input
                  className="bg-white h-60"
                  type="text"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setIsValidEmail(true); // Reset validation state on input change
                  }}
                />
              </div>

              <div>
                <button
                  className="button -md h-60 text-white rounded-5"
                  style={{ background: "#679d97" }}
                  onClick={handleSubmit}
                >
                  {loading ? <CircularProgress /> : "Subscribe"}
                </button>
              </div>
            </div>
            {responseMessage && (
              <p style={{ color: subsApply.success ? "red" : "green" }}>
                {responseMessage}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActions;
